<template>
  <el-dialog
    class="progress"
    title="上传结果"
    :show-close="showClo"
    width="500px"
    :close-on-press-escape="false"
    :visible.sync="dialogVisible"
  >
    <!--    上传结果文本-->
    <p style="color: green;text-align: center">
      本次共成功上传{{ successPic.length }}个文件，{{ failure.length }}个失败。
    </p>
    <!--    上传进度列表-->
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        :data="tableData"
        :fit="true"
        class="ccui-multifunctional-table"
      >
        <el-table-column prop="picUrl" label="文件" width="65">
          <template slot-scope="scope">
            <img style="width: 33px; height: 33px" :src="scope.row.picUrl" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" width="115">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="size" label="大小" width="85">
          <template slot-scope="scope">{{ scope.row.size }}</template>
        </el-table-column>
        <el-table-column prop="package" label="文件夹" width="115">
          <template slot-scope="scope">{{ scope.row.value }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <div :style="`color:${getColor(scope.row.status)}`">
              {{ scope.row.status }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    尾部-->
    <span slot="footer" class="dialog-footer">
      <el-button
        size="mini"
        type="default-mini"
        @click="addMore"
        :disabled="uploadOver"
        >添加更多图片</el-button
      >
      <el-button
        size="mini"
        type="primary-font-mini"
        @click="determine"
        :disabled="uploadOver"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "uploadProgress",
  props: ["updateData", "uploadOver", "value", "successPic", "failure"],
  data() {
    return {
      showClo: true, //取消右上角关闭按钮
      dialogVisible: false, //弹框隐藏与否
      tableData: this.updateData, //父组件传过来的表格数据赋值给tabledata
      imgStauts: {
        isJPG: true,
        isLt5M: true,
        isName: true
      } //上传限制
    };
  },
  methods: {
    //判断上传状态给不同字体颜色
    getColor(status) {
      let color;
      if (status === "上传失败") {
        color = "#FF142F";
      }
      if (status === "上传成功") {
        color = "#00956C";
      }
      return color;
    },
    // 上传图片弹框打开
    openProgress() {
      this.dialogVisible = true;
    },
    // 调用图片限制报错提示
    beforeAvatarUpload(file) {
      console.log("上传前", file);
      const isJPG = [
        "image/jpeg",
        "image/gif",
        "image/png",
        "image/jpg"
      ].includes(file.type);
      const isLt5M = file.size / 1024 / 1024 < 5;
      const isName = file.name.length < 100;
      if (!isJPG && this.imgStauts.isJPG) {
        this.imgStauts.isJPG = false;
        this.$message({
          showClose: true,
          message: "上传图片只能是 png/jpeg/jpg/gif格式!",
          type: "error",
          ccuiCustom: true,
          duration: 8000,
          customClass: "zcindex"
        });
      }
      if (!isLt5M && this.imgStauts.isLt5M) {
        this.imgStauts.isLt5M = false;
        this.$message({
          showClose: true,
          message: "上传图片大小不能超过 5MB!",
          type: "error",
          ccuiCustom: true,
          duration: 8000,
          customClass: "zcindex"
        });
      }
      if (!isName && this.imgStauts.isName) {
        this.imgStauts.isName = false;
        this.$message({
          showClose: true,
          message: "图片名称超过100个字，不允许上传!",
          type: "error",
          ccuiCustom: true,
          duration: 8000,
          customClass: "zcindex"
        });
      }
      return isJPG && isLt5M && isName;
    },
    //添加更多图片
    addMore() {
      this.imgStauts = {
        isJPG: true,
        isLt5M: true,
        isName: true
      };
      this.dialogVisible = false;
      this.tableData = [];
      this.$emit("getFileList", this.tableData);
    },
    //点击确定
    determine() {
      this.imgStauts = {
        isJPG: true,
        isLt5M: true,
        isName: true
      };
      this.dialogVisible = false;
      this.$emit("closeDigLog");
      // this.$emit('clearDate')
      this.tableData = [];
      this.$emit("getFileList", this.tableData);
    }
  }
};
</script>

<style>
/deep/.has-gutter .cell {
  display: flex !important;
  align-items: center !important;
  height: 26px !important;
  background: #f1f1f1;
}
.zcindex {
  z-index: 9999 !important;
}
/deep/.cell {
  color: #999999;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #999999;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
</style>
